import React, { Component } from 'react'
import OverallReportsCollege from '../components/overallCollegeReport/OverallReportsCollege'

class OverallCollegeReport extends Component {

    render() {
        return (
            <div>
                <OverallReportsCollege />
            </div>
        );
    }
}

export default OverallCollegeReport